import gql from "graphql-tag";

export const getMonitoringServicesByCoordinatorId = gql`
  query GetMonitoringServices(
    $where: MonitoringServicesInput
    $skip: Int,
    $first: Int,
  ){
    monitoringServices(
      where: $where
      skip: $skip,
      first: $first
    ) {
      count
      scheduledExpertServices{
        id
        serviceDate
        status
        duration
        expertComments
        deliveredAt
        acceptedAt
        updatedAt
        assignedExpertService {
          id
          status
          finished
          availableUnits
          assignedUnits
          assignmentNumber
          assignationIdentifier
          assignmentDate
          limitDate
          expertServicePrice
          expertServiceData
          isProbono
          expertService {
            id
            name
            type
            price
            method
            category
            expert {
              id
              fullName
              firstName
              middleName
              lastName
            }
          }
          batch {
            id
            name
            program {
              id
              name
            }
          }
          ode {
            id
            name
            team {
              id
              fullName
              email
              phone
              systemRole
            }
          }
        }
      }
    }
  }
`;
